<aside sk-panel-tab-view [skTitle]="panelTitle" [views]="Views">
    <footer>
        <button id="primaryButton" sk-spinner-button class="mr-100" [color]="'primary'" (click)="update()" [isSpinning]="actionButtonsService.setPrimaryIsBusy$ | async" 
            [disabled]="(actionButtonsService.setPrimaryIsBusy$ | async) || (actionButtonsService.setPrimaryIsDisabled$ | async)">Update
        </button>
        <button id="cancel" type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
    </footer>
</aside>